module.exports = __webpack_public_path__ + "img/mTelegram.ecff370.svg";